<div class="footer-card-w" aria-labelledby="services-heading">
  <ul class="footer-card-w_items" role="list">
    <a class="footer-card-w_items_logo" routerLink="/">
      <img src="./assets/svgs/logo.svg" alt="logo" />
    </a>

    <li *ngFor="let record of footerNavRecords" class="footer-card-w_items_item">
      <h3 id="services-heading" class="footer-card-w_heading">{{ record.headingKey | translate }}</h3>

      <p
        *ngFor="let nav of record.items; let j = index"
        class="footer-card-w_items_item_item-text"
        (click)="onFooterNavClick(nav.path)"
        role="link"
        tabindex="0"
      >
    {{ nav.i18nKey | translate }}
  </p>
    </li>

  </ul>
</div>
